export default __webpack_public_path__ + "static/media/BIGBASKET.d2819fde.png";